<template>
    <div class="common-box">
        
        <div class="common-header">   
            <img :src="backSrc"  class="back-img" @click="back"/>
            宣教详情
        </div>
    
        <div class="common-content-box">

            <div class="p-content-box">
                <div class="title" v-html="data.edu_content">  </div>
                <ul class="intro-box">
                    <li> 患者：{{data.patientInfo.xingming}}  {{data.patientInfo.xingbie}}  {{data.patientInfo.nianling}} </li>
                    <li v-if="data.edu_object"> 教育对象：{{data.edu_object}} </li>
                    <li v-if="data.edu_opporunity"> 教育时机：{{data.edu_opporunity}} </li>
                    <li v-if="data.edu_project"> 教育项目：{{data.edu_project}} </li>
                </ul>
                <div class="content-box" v-html="data.edu_detail_sub">
                </div>
            </div>

            <div class='qianzi-box'>
                <div class='qian'> 
                    <span> 患者签名：</span>
                    <img :src="data.patient_or_principal_sign" />
                </div>
                <div class="date-box">
                    <span> 签名日期： {{data.sign_date}}</span> 
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    
    import { getInfoById , addQianming } from '@/service/getData'
    import { Toast } from 'vant';

    export default {
        name: "index",
        components: {
          
        },
        data: function () {
            return {
                backSrc:require("@/assets/image/back.png"),
                data:{
                    edu_content:"",
                    edu_project:"",//宣教内容
                    edu_object:"", //教育对象
                    edu_opporunity:"" , //教育时机
                    edu_project:"" , // 教育项目
                    edu_detail_sub:"" , //子内容
                    patientInfo:{
                        xingming:"",
                        xingbie:"",
                        nianling:"",
                        zhenduan:""
                    },
                    patient_or_principal_sign:"",
                    sign_date:""
                },
                edu_object:"病人"
            };
        },
        beforeMount: function () {
            
        },
        mounted: function () {

            let xuanjiao_id = this.$route.query.xuanjiao_id;
            let yiyuan_id = this.$route.query.yiyuan_id;

            getInfoById(xuanjiao_id , yiyuan_id).then(res => {

                this.data = res.data;

                var divObj = document.createElement('div');
                divObj.innerHTML = this.data.edu_detail_sub;

                var imgs = divObj.getElementsByTagName('img');

                for(var i = 0 ; i < imgs.length ; i++){

                    imgs[i].style.width = "90%";
                    imgs[i].style.height = "auto";
                    imgs[i].width = "";
                    imgs[i].height = "";
                }

                var videos = divObj.getElementsByTagName('video');

                for(var i = 0 ; i < videos.length ; i++){

                    videos[i].style.width = "90%";
                    videos[i].style.height = "auto";
                    videos[i].width = "";
                    videos[i].height = "";
                }

                this.data.edu_detail_sub = divObj.innerHTML;

                /*
                if(res.code == 200){    

                }else{
                    Toast(res.msg);
                }*/

            });
        },
        updated: function () {

        },
        methods: {
           back(){

                let open_id = this.$route.query.open_id;

                this.$router.push({
                    path: "/list",
                    query:{
                        'open_id':open_id
                    }
                });
           }
        }
    };
</script>

<style lang="scss" scoped>
    @import "./style/index.scss";
</style>

<style type="text/css">
</style>

